import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f0cba6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "name", "disabled", "value"]
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ticket-type", { disabled: _ctx.disabled }])
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "radio",
      id: _ctx.id,
      name: _ctx.name,
      disabled: _ctx.disabled,
      value: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
    }, null, 8, _hoisted_1), [
      [_vModelRadio, _ctx.inputValue]
    ]),
    _createElementVNode("label", { for: _ctx.id }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.ticket.title), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.ticket.type === _ctx.TicketTypeEnum[_ctx.TicketTypeEnum.Standard] ? 'Included': `£ ${_ctx.ticket.price.toFixed(2)}`), 1)
      ]),
      _createElementVNode("div", {
        class: "ticket-type__body",
        innerHTML: _ctx.ticket.body
      }, null, 8, _hoisted_6)
    ], 8, _hoisted_2)
  ], 2))
}